import { brandCodeMap } from '@/constants';
import { comm, base } from '../base';
// export const input = {
//   input: {
//     navBgc: base.color.c0023,
//     color: base.color.c0014,
//     inputLabelBg: base.color.c0023,
//     inputBg: comm.color.cffff,
//   },
//   formInput: {
//     color: comm.color.cffff,
//     singInputBg: base.color.c0024,
//     singInputColor: base.color.c0015,
//     inputBg: base.color.c0026,
//   },
// };
const selecTheme = {};

for (const item of Object.keys(brandCodeMap)) {
  selecTheme[item] = {
    formSelect: {
      color: comm.color.cffff,
      singSelectBg: base[item]?.selecColor.c0023,
      addSingSelectBd: base[item]?.selecColor.c0024,
      addSingSelectBdNew: base[item]?.selecColor.c0002,
      singSelectColor: base[item]?.selecColor.c0015,
      selectBg: base[item]?.selecColor.c0026,
      selectColor: base[item]?.selecColor.transparent,
      editSelectBg: base[item]?.selecColor.c0006,
      labelColor: base[item]?.selecColor.c0014,
      inputBorder: base[item]?.selecColor.c0007,
      selectDisBg: comm.color.c0001,
      selectBgfff: comm.color.cffff,
      labelBorColor: base[item]?.selecColor.c0008,
      inputColor: base[item]?.selecColor.c0014,
      fontSize: comm.fontSize.s04,
    },
  };
}

export const select = selecTheme;
